import React from "react";
import Slider from "react-slick";

const reviews = [
  { name: "Rahul Sharma", review: "Amazing experience! I won instantly!", stars: 5 },
  { name: "Priya Mishra", review: "Very smooth process!", stars: 4 },
  { name: "Karthik Rao", review: "Super fast and trusted!", stars: 5 },
  { name: "Meena Raj", review: "Excellent service!", stars: 5 },
  { name: "Suresh Kumar", review: "Loved the design!", stars: 4 },
  { name: "Anitha Devi", review: "Very user-friendly!", stars: 5 },
];

const Review = () => {
  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 800,
    slidesToShow: 3,   // ⭐ SHOW 3 CARDS AT ONCE
    slidesToScroll: 1,
    pauseOnHover: false,
    arrows: false,

    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } }
    ]
  };

  return (
    <div className="ticket-grid-container1">
      <h2 className="main-title">🎟️ Customer Review Lottery Cards</h2>

      <Slider {...settings}>
        {reviews.map((r, i) => (
          <div key={i} className="ticket-wrapper">
            <div className="lottery-ticket">
              <div className="shine"></div>

              <div className="cut-line"></div>

              <div className="ticket-header">
                <h3>{r.name}</h3>
              </div>

              <div className="scratch-area">
                <p className="stars">{"⭐".repeat(r.stars)}</p>
                <p className="review-text">{r.review}</p>
              </div>

              <div className="ticket-footer">
                ⭐ Thank you for your feedback ⭐
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default Review;
